export { useFirebaseData, useFirebaseDataForMultipleDocIds } from './use-firebase-data';
